module.exports = __webpack_public_path__ + "static/img/doghead.34806a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doghead.png
// module id = JOt8
// module chunks = 14